<div class="actions">
  <div class="left">
    <ng-content select="[left]"></ng-content>
  </div>

  <div class="center">
    <ng-content select="[center]"></ng-content>
  </div>

  <div class="right">
    <ng-content select="[right]"></ng-content>
  </div>
</div>
